import { InfoIcon } from '@assets/icons';
import CustomIcon from '@components/utils/CustomIcon';
import { PaletteColor } from '@utils/types';
import Typography from '@components/Typography';

import {
  InfoIconWrapper,
  WarningMessageContainer,
  WarningMessageText,
} from './styled';

const Announcement = ({
  text,
  paletteColor = 'clearBlue',
}: {
  text: React.ReactNode;
  paletteColor?: PaletteColor;
}) => {
  return (
    <WarningMessageContainer>
      <InfoIconWrapper>
        <CustomIcon icon={InfoIcon} fontSize={24} paletteColor={paletteColor} />
      </InfoIconWrapper>
      <WarningMessageText>
        <Typography variant='caption2' weight='SemiBold' color='B200'>
          {text}
        </Typography>
      </WarningMessageText>
    </WarningMessageContainer>
  );
};

export default Announcement;
